const INTCMP_TEMPLATE_TEXT = 'skysport_livematch_<%intcmp%>_tab';
const INTCMP_LGP_TEMPLATE_TEXT = 'skysport_sportsdata_<%intcmp%>_tab';

export const composeIntcmp = (tabName: string, variant?: string) =>
  (variant === 'LGP' ? INTCMP_LGP_TEMPLATE_TEXT : INTCMP_TEMPLATE_TEXT).replace('<%intcmp%>', tabName);

export const trackIntcmp = (tabName: string) => {
  const intcmp = composeIntcmp(tabName);
  localStorage.setItem('intcmp', intcmp);
};

/** Hydrate intcmp on  */
export const hydrateIntcmp = (element: HTMLElement) => {
  const intcmpArray = Array.from(element.querySelectorAll('[data-intcmp]'));
  intcmpArray.forEach((elm) => {
    const listener: EventListener = () => {
      const intcmpAtt = elm.getAttribute('data-intcmp');
      localStorage.setItem('intcmp', intcmpAtt || '');
    };
    elm.addEventListener('click', listener);
  });
};
